var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Number(_vm.previousNumber) !== 0 && isFinite(_vm.previousNumber))?_c('div',{staticClass:"d-inline ml-1"},[_c('font-awesome-icon',{staticClass:"small fa-sm",class:(!_vm.opposite && _vm.previousNumber > 0) || (_vm.opposite && _vm.previousNumber < 0)
        ? 'text-success'
        : (!_vm.opposite && _vm.previousNumber < 0) ||
          (_vm.opposite && _vm.previousNumber > 0)
        ? 'text-danger'
        : 'd-none',attrs:{"icon":_vm.previousNumber > 0
        ? 'arrow-up'
        : _vm.previousNumber < 0
        ? 'arrow-down'
        : 'arrow-up'}}),_vm._v(" "),_c('span',{staticClass:"font-weight-thin fs-14",class:(!_vm.opposite && _vm.previousNumber > 0) || (_vm.opposite && _vm.previousNumber < 0)
        ? 'text-success'
        : (!_vm.opposite && _vm.previousNumber < 0) ||
          (_vm.opposite && _vm.previousNumber > 0)
        ? 'text-danger'
        : 'text-muted'},[_vm._v(_vm._s(_vm.abs(_vm.previousNumber))+"%")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a719e76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompareStat.vue
// module id = null
// module chunks = 